import { SiteFooterType } from '../models/site-footer-type.enum';
import { SiteHeaderType } from '../models/site-header-type.enum';

export class LayoutStateModel {
  public theme: string;
  public sidenav: LayoutSidenav;
  public siteHeader: SiteHeaderType;
  public siteFooter: SiteFooterType;
}

export class LayoutSidenav {
  enabled: boolean;
  open: boolean;
}
